module.exports = __webpack_public_path__ + "img/5.2.eb7dfc9b.svg";